// Constantes & helper partagés pour l'upload ZIP de documents

export const TYPE_OPTIONS = [
  { value: 'permis_construire', label: 'Permis de construire' },
  { value: 'declaration_ouverture_chantier', label: "Déclaration d'ouverture de chantier" },
  { value: 'plans_architecture', label: "Plans d'architecture" },
  { value: 'plan_masse', label: 'Plan de masse' },
  { value: 'etudes_techniques', label: 'Études techniques' },
  { value: 'attestation_assurance_intervenants', label: 'Attestation assurance' },
  { value: 'devis_intervenants', label: 'Devis intervenants' },
  { value: 'justificatif_immatriculation', label: 'Justificatif immatriculation' },
  { value: 'pv_reception', label: 'PV de réception' },
  { value: 'daact', label: 'DAACT' },
  { value: 'dossier_maitre_signe', label: 'Dossier Maître signé' },
  { value: 'kbis', label: 'KBIS' },
  { value: 'autre_document', label: 'Autre document' },
];

export const FAMILY_COLORS = {
  Chantier: 'bg-blue-100 text-blue-700 border-blue-200',
  Assurance: 'bg-purple-100 text-purple-700 border-purple-200',
  Identite: 'bg-amber-100 text-amber-700 border-amber-200',
  Autre: 'bg-slate-100 text-slate-600 border-slate-200',
};

// Heuristique : valide = type ET date renseignés
export function isRowValid(item, overrides) {
  const ov = overrides[item.filename] || {};
  const t = ov.type_document || item.type_document;
  const d = ov.date_origine !== undefined ? ov.date_origine : item.date_origine_auto;
  return Boolean(t && t !== 'autre_document' && d);
}
